// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

import { Icons } from '../Icons/Icons';
import { Button } from '../Button/Button';

import styles from './Alert.module.css';

export const Alert = ({
  variant,
  message,
  onClick,
  showClose = false,
  iconSize = '20px',
  clipboardError = null,
}) => {
  const handleCopy = e => {
    e.stopPropagation();

    if (!clipboardError) {
      return;
    }

    const formatted = JSON.stringify(clipboardError, null, 2);

    navigator.clipboard.writeText(formatted);
  };
  return (
    <div>
      {showClose && (
        <div className={styles.alert_header}>
          <div className={styles.header_control}>
            {clipboardError && (
              <Button
                color='light'
                iconType='pasteLine'
                onClick={handleCopy}
                sizing
                aria-label='Copy error details'
                classname={styles.copy_button}
              >
                Copy details
              </Button>
            )}
            <Button onClick={onClick} color='light' data-dismiss='alert' aria-label='Close'>
              <Icons iconType='close' />
            </Button>
          </div>
        </div>
      )}
      <div className={styles.alert_container}>
        <div>
          <Icons iconType={variant} stroke={`var(--color-${variant})`} iconSize={iconSize} />
        </div>
        <div>{message}</div>
      </div>
    </div>
  );
};
